export default "__VITE_ASSET__CsyKvWup__"